/**
 * Compact analytics tile showing the top-5 placements hosting participants
 * starting this month.  Extracted from `ProgramBooking.jsx` (iter 57.43) so
 * the page stays focussed on the table + modals.  Pure presentational — the
 * grouping/aggregation is still done in the parent so we don't refetch.
 */
export default function PlacementAnalyticsCard({ summary }) {
  if (!summary || summary.monthCount === 0) return null;
  return (
    <div className="aii-card p-4" data-testid="pb-placement-analytics">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-2">
        <div>
          <div className="text-[10px] uppercase tracking-widest text-brand font-bold">Placement analytics · {summary.ym}</div>
          <div className="text-xs text-[color:var(--aii-muted)]">{summary.monthCount} participant{summary.monthCount === 1 ? "" : "s"} starting this month · {summary.unassigned} unassigned</div>
        </div>
        {summary.top.length === 0 && <span className="text-xs italic text-[color:var(--aii-muted)]">No placements assigned yet this month.</span>}
      </div>
      {summary.top.length > 0 && (
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-2" data-testid="pb-placement-analytics-list">
          {summary.top.map(([name, count]) => {
            const total = summary.monthCount || 1;
            const pct = Math.round((count / total) * 100);
            return (
              <li key={`ps-${name}`} className="border border-[color:var(--aii-border)] rounded-md p-2.5" data-testid={`pb-placement-tile-${name}`}>
                <div className="text-xs font-semibold truncate" title={name}>{name}</div>
                <div className="mt-1 flex items-baseline gap-1">
                  <span className="text-2xl font-display font-semibold text-brand">{count}</span>
                  <span className="text-[10px] text-[color:var(--aii-muted)]">{pct}% of month</span>
                </div>
                <div className="mt-1 h-1 rounded bg-[color:var(--aii-border)] overflow-hidden">
                  <div className="h-full bg-brand" style={{ width: `${pct}%` }}/>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
